import { useMutation } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import {
    AdminSetUserPasswordInputDto,
    AdminSetUserPasswordOutputDto,
} from '../../../models/user/dto/admin-set-user-password.dto';

/**
 * Admin-set password for a user of the current organization. Nothing in the
 * user payload changes (the credential lives in Firebase, not the DB), so
 * there is deliberately no query invalidation here.
 */
export function useSetUserPassword(userId: string) {
    const apiClient = useApiClient();

    return useMutation({
        mutationFn: async (dto: AdminSetUserPasswordInputDto) => {
            return apiClient.fetchApi<AdminSetUserPasswordOutputDto, AdminSetUserPasswordInputDto>({
                method: 'POST',
                endpoint: `users/${userId}/password`,
                body: dto,
            });
        },
    });
}
